import { createSelector } from 'reselect'
import _ from 'lodash'
import { getResidentsList, getUserHome, getZonesList } from './Lists'
import { applyFiltersToList } from './helpers'

import { colors } from '@lmc/common/constants'

export const chooseSelectedResident = createSelector(
  [getResidentsList],
  (residents) => {
    if (!residents) return null
    const active = _.filter(residents, (res) =>
      ['active', 'pre-assessment'].includes(res.status)
    )
    if (!active || !active.length) {
      // fix(CARE-1388): ensure at least one resident is selected
      if (residents.length) return residents[0].id
    }
    return active[0].id
  }
)

const getResidentId = (state, { id }) => id
export const getResidentProfile = createSelector(
  [getResidentsList, getResidentId],
  (residents, id) => {
    if (!residents || !id) return null
    return _.find(residents, { id })
  }
)

const getCurrentFilters = (state) => state.global.filters.residents

export const sortFilteredResidents = createSelector(
  [getResidentsList, getCurrentFilters],
  (residents, filters, sortType) => {
    if (!residents) return null
    if (!filters) return residents
    const result = applyFiltersToList(filters, residents)
    const noActive = !_.find(residents, { status: 'active' })
    if (!result.length && noActive) return residents
    return applyFiltersToList(filters, residents)
  }
)

export const getResidentFilters = createSelector(
  [getResidentsList, getUserHome, getZonesList],
  (residents, features, zones) => {
    if (!residents || !features) return null

    const statusCounts = _.countBy(residents, 'status')
    const zoneCounts = _.countBy(residents, 'zone')

    const status = {
      ...INITIAL_FILTERS.status,
      filters: _(INITIAL_FILTERS.status.filters)
        .map((filter) => {
          if (filter.value === 'pre-assessment' && !features.carePlans) {
            return null
          }
          return {
            ...filter,
            count: statusCounts[filter.value] || 0,
          }
        })
        .compact()
        .value(),
    }

    const zone = {
      ...INITIAL_FILTERS.zone,
      filters: zones?.length
        ? zones.map((zone) => ({
            label: zone.name,
            value: zone.id,
            count: zoneCounts[zone.id] || 0,
          }))
        : [],
    }

    return features.pro ? { status, zone } : { status }
  }
)

const INITIAL_FILTERS = {
  status: {
    label: 'Status',
    filters: [
      {
        label: 'Initial Assessment',
        value: 'pre-assessment',
        badgeColor: colors.orange,
        badgeText: 'INITIAL',
      },
      { value: 'active' },
      { value: 'inactive' },
      { value: 'hospitalised' },
      { value: 'deceased' },
      { value: 'discharged' },
      { value: 'dummy' },
    ],
  },
  zone: {
    label: 'Zone',
    filters: [],
  },
}
